import { List, ListSubheader, Stack, Typography } from "@mui/material";
import React, { PropsWithChildren } from "react";

export const ServiceOptionGroup = ({
  group,
  children,
}: PropsWithChildren<{
  group: string;
}>) => {
  return (
    <Stack>
      <ListSubheader disableSticky sx={{ height: "auto" }}>
        <Typography
          variant="labelTiny"
          color="text.secondary"
          sx={{
            fontWeight: "bold",
          }}
        >
          {group}
        </Typography>
      </ListSubheader>
      <List>{children}</List>
    </Stack>
  );
};
